import React, { useState } from 'react';

const KLUBOVI = ['KK Rad', 'KK Rad 2', 'ZKK Olimp'];
const SEZONE = ['2025/2026', '2026/2027'];
const TAKMICENJA = ['Premijer liga', 'Prva liga RS', 'Kup RS', 'Kup BiH'];

function DetaljiUtakmice({ utakmica, igraci, updateUtakmicu, obrisiUtakmicu, setAktivna, jeAdmin }) {
  const [editMode, setEditMode] = useState(false);
  const [rezultati, setRezultati] = useState(null);
  const [editIzmjene, setEditIzmjene] = useState([]);
  const [editInfo, setEditInfo] = useState({});

  if (!utakmica) return (
    <div className="card empty-state">
      <div className="icon">🎳</div>
      <p>Utakmica nije pronadjena.</p>
      <button className="btn-secondary" style={{ marginTop: '12px' }}
        onClick={() => setAktivna({ strana: 'utakmice' })}>← Nazad</button>
    </div>
  );

  const getUkupnoHitac = (izmjena) => {
    if (!izmjena) return '';
    if (izmjena.ukupnoHitac) return izmjena.ukupnoHitac;
    if (izmjena.set && izmjena.bacanje) {
      return (parseInt(izmjena.set) - 1) * 30 + parseInt(izmjena.bacanje);
    }
    return '';
  };

  const initEdit = () => {
    const r = {};
    utakmica.rezultati?.forEach(igrac => {
      r[igrac.igracId] = {
        ukupnoPune: igrac.ukupnoPune || 0,
        ukupnoCis: igrac.ukupnoCis || 0,
        promasajiOsnovni: igrac.promasaji || 0,
        sp: igrac.sp || 0,
        mp: igrac.mp || 0,
        napredna: igrac.napredna || false,
        1: { pune: igrac.set1?.pune || 0, cis: igrac.set1?.cis || 0, sp: igrac.set1?.sp || 0, promasaji: igrac.set1?.promasaji || 0 },
        2: { pune: igrac.set2?.pune || 0, cis: igrac.set2?.cis || 0, sp: igrac.set2?.sp || 0, promasaji: igrac.set2?.promasaji || 0 },
        3: { pune: igrac.set3?.pune || 0, cis: igrac.set3?.cis || 0, sp: igrac.set3?.sp || 0, promasaji: igrac.set3?.promasaji || 0 },
        4: { pune: igrac.set4?.pune || 0, cis: igrac.set4?.cis || 0, sp: igrac.set4?.sp || 0, promasaji: igrac.set4?.promasaji || 0 },
      };
    });
    setRezultati(r);
    setEditInfo({
      datum: utakmica.datum || '',
      kolo: utakmica.kolo || '',
      sezona: utakmica.sezona || '2025/2026',
      klub: utakmica.klub || KLUBOVI[0],
      protivnik: utakmica.protivnik || '',
      protivnikCunjevi: utakmica.protivnikCunjevi || '',
      domaci: utakmica.domaci ?? true,
      takmicenje: utakmica.takmicenje || 'Premijer liga',
    });

    // Trazi igraca koji ulazi iz izmjena array
    const izmjeneArr = utakmica.izmjene || [];
    const editIzmjeneInit = utakmica.rezultati?.map(igrac => {
      const izmjenaVani = izmjeneArr.find(iz => iz.igracVani === igrac.igracId);
      const izmjenaUnutra = izmjeneArr.find(iz => iz.igracUnutra === igrac.igracId);
      const izmjena = igrac.izmjena;
      let igracKojiUlaziId = '';
      let igracKojiUlaziIme = '';
      if (izmjenaVani) {
        const igracUnutra = igraci.find(i => i.id === izmjenaVani.igracUnutra);
        igracKojiUlaziId = izmjenaVani.igracUnutra || '';
        igracKojiUlaziIme = igracUnutra?.ime || '';
      }
      return {
        igracId: igrac.igracId,
        igracIdEdit: igrac.igracId,
        ime: igrac.ime,
        imaIzmjenu: !!izmjena || !!izmjenaVani,
        tip: izmjena?.tip || (izmjenaUnutra ? 'ulaz' : 'izlaz'),
        ukupnoHitac: getUkupnoHitac(izmjena) || izmjenaVani?.ukupnoHitac || '',
        igracKojiUlaziId,
        igracKojiUlaziIme,
      };
    }) || [];

    // Dodaj igraca koji ulazi ako nije u rezultatima
    izmjeneArr.forEach(iz => {
      if (iz.igracUnutra) {
        const vecPostoji = utakmica.rezultati?.some(r => r.igracId === iz.igracUnutra);
        if (!vecPostoji) {
          const igracUnutra = igraci.find(i => i.id === iz.igracUnutra);
          if (igracUnutra) {
            editIzmjeneInit.push({
              igracId: iz.igracUnutra,
              igracIdEdit: iz.igracUnutra,
              ime: igracUnutra.ime,
              imaIzmjenu: true,
              tip: 'ulaz',
              ukupnoHitac: iz.ukupnoHitac || '',
              igracKojiUlaziId: '',
              igracKojiUlaziIme: '',
              noviIgrac: true,
            });
            r[iz.igracUnutra] = {
              ukupnoPune: 0, ukupnoCis: 0, promasajiOsnovni: 0,
              sp: 0, mp: 0, napredna: false,
              1: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
              2: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
              3: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
              4: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
            };
          }
        }
      }
    });

    setRezultati(r);
    setEditIzmjene(editIzmjeneInit);
    setEditMode(true);
  };

  const updateRezultat = (igracId, set, polje, vrijednost) => {
    setRezultati(prev => ({
      ...prev,
      [igracId]: { ...prev[igracId], [set]: { ...prev[igracId]?.[set], [polje]: vrijednost } }
    }));
  };

  const updateIzmjena = (igracId, polje, vrijednost) => {
    setEditIzmjene(prev => prev.map(iz =>
      iz.igracId === igracId ? { ...iz, [polje]: vrijednost } : iz
    ));
  };

  const getIzmjenaSetRange = (izmjenaEdit) => {
    let setOd = 1, setDo = 4;
    if (izmjenaEdit?.imaIzmjenu && parseInt(izmjenaEdit?.ukupnoHitac) > 0) {
      const hitac = parseInt(izmjenaEdit.ukupnoHitac);
      if (izmjenaEdit.tip === 'izlaz') {
        const kugleBacene = hitac - 1;
        setDo = kugleBacene === 0 ? 1 : Math.min(Math.ceil(kugleBacene / 30), 4);
      } else {
        setOd = Math.min(Math.ceil(hitac / 30), 4);
      }
    }
    return { setOd, setDo };
  };

  const izracunajIgraca = (igracId) => {
    const r = rezultati?.[igracId] || {};
    const izmjenaEdit = editIzmjene.find(iz => iz.igracId === igracId);
    const forceNapredna = izmjenaEdit?.imaIzmjenu && parseInt(izmjenaEdit?.ukupnoHitac) > 0;
    const napredna = r.napredna || forceNapredna;
    if (napredna) {
      const { setOd, setDo } = getIzmjenaSetRange(izmjenaEdit);
      let ukupnoPune = 0, ukupnoCis = 0, ukupno = 0, sp = 0, promasaji = 0;
      for (let s = setOd; s <= setDo; s++) {
        const set = r[s] || {};
        const pune = parseFloat(set.pune) || 0;
        const cis = parseFloat(set.cis) || 0;
        ukupnoPune += pune;
        ukupnoCis += cis;
        ukupno += pune + cis;
        sp += parseFloat(set.sp) || 0;
        promasaji += parseFloat(set.promasaji) || 0;
      }
      return { ukupnoPune, ukupnoCis, ukupno, sp, mp: parseFloat(r.mp) || 0, promasaji };
    } else {
      const ukupnoPune = parseFloat(r.ukupnoPune) || 0;
      const ukupnoCis = parseFloat(r.ukupnoCis) || 0;
      return {
        ukupnoPune, ukupnoCis,
        ukupno: ukupnoPune + ukupnoCis,
        sp: parseFloat(r.sp) || 0,
        mp: parseFloat(r.mp) || 0,
        promasaji: parseFloat(r.promasajiOsnovni) || 0,
      };
    }
  };

  const handleSacuvaj = async () => {
    // Uključi i noviIgrac (ulaznog igrača koji nije bio u originalnim rezultatima)
    const noviIgraciEntries = editIzmjene
      .filter(iz => iz.noviIgrac)
      .map(iz => ({
        igracId: iz.igracId, ime: iz.ime,
        napredna: false, izmjena: null,
        set1: {}, set2: {}, set3: {}, set4: {},
        ukupnoPune: 0, ukupnoCis: 0, ukupno: 0, sp: 0, mp: 0, promasaji: 0,
      }));

    const sviIgraciBase = [...(utakmica.rezultati || []), ...noviIgraciEntries];

    const noviRezultati = sviIgraciBase.map(igrac => {
      const r = rezultati[igrac.igracId] || {};
      const izmjenaEdit = editIzmjene.find(iz => iz.igracId === igrac.igracId);
      const odabraniIgrac = igraci.find(i => i.id === izmjenaEdit?.igracIdEdit);

      // Igrači sa izmjenom uvijek koriste per-set unos
      const forceNapredna = izmjenaEdit?.imaIzmjenu && parseInt(izmjenaEdit?.ukupnoHitac) > 0;
      const napredna = r.napredna || forceNapredna;

      // Opseg setova koji igrač stvarno igra
      const { setOd, setDo } = getIzmjenaSetRange(izmjenaEdit);

      const getSetData = (sNum) => {
        if (!napredna) return igrac['set' + sNum] || {};
        if (sNum < setOd || sNum > setDo) return {};
        return { pune: parseFloat(r[sNum]?.pune) || 0, cis: parseFloat(r[sNum]?.cis) || 0, sp: parseFloat(r[sNum]?.sp) || 0, promasaji: parseFloat(r[sNum]?.promasaji) || 0 };
      };

      let izmjenaInfo = null;
      if (izmjenaEdit?.imaIzmjenu && izmjenaEdit?.ukupnoHitac) {
        izmjenaInfo = {
          tip: izmjenaEdit.tip,
          ukupnoHitac: parseInt(izmjenaEdit.ukupnoHitac),
        };
      }

      const s = izracunajIgraca(igrac.igracId);

      return {
        ...igrac,
        igracId: izmjenaEdit?.igracIdEdit || igrac.igracId,
        ime: odabraniIgrac?.ime || igrac.ime,
        napredna: !!napredna,
        izmjena: izmjenaInfo,
        set1: getSetData(1),
        set2: getSetData(2),
        set3: getSetData(3),
        set4: getSetData(4),
        ukupnoPune: s.ukupnoPune,
        ukupnoCis: s.ukupnoCis,
        ukupno: s.ukupno,
        sp: s.sp,
        mp: s.mp,
        promasaji: s.promasaji,
      };
    });

    // Rekonstruiši izmjene array za bazu
    const novaIzmjena = editIzmjene
      .filter(iz => iz.imaIzmjenu && iz.tip === 'izlaz' && iz.ukupnoHitac)
      .map(iz => ({
        igracVani: iz.igracId,
        igracUnutra: iz.igracKojiUlaziId || '',
        ukupnoHitac: parseInt(iz.ukupnoHitac),
      }));

    let ekipaUkupno = 0, ekipaSP = 0, ekipaMP = 0, ekipaPromasaji = 0;
    noviRezultati.forEach(r => {
      ekipaUkupno += r.ukupno;
      ekipaSP += r.sp;
      ekipaMP += r.mp;
      ekipaPromasaji += r.promasaji;
    });

    const protivnikCunjeviInt = parseFloat(editInfo.protivnikCunjevi) || 0;
    const bonusMP = protivnikCunjeviInt > 0
      ? (ekipaUkupno > protivnikCunjeviInt ? 2 : ekipaUkupno < protivnikCunjeviInt ? 0 : 1)
      : 0;
    const ukupnoMP = ekipaMP + bonusMP;
    const protivnikMP = 8 - ukupnoMP;
    let ekipaBodovi = 0;
    if (ukupnoMP > protivnikMP) ekipaBodovi = 2;
    else if (ukupnoMP === protivnikMP) ekipaBodovi = 1;
    else ekipaBodovi = 0;

    await updateUtakmicu(utakmica.id, {
      datum: editInfo.datum,
      kolo: parseInt(editInfo.kolo),
      sezona: editInfo.sezona,
      klub: editInfo.klub,
      protivnik: editInfo.protivnik,
      domaci: editInfo.domaci,
      takmicenje: editInfo.takmicenje || 'Premijer liga',
      rezultati: noviRezultati,
      izmjene: novaIzmjena,
      protivnikCunjevi: protivnikCunjeviInt,
      ekipaUkupno, ekipaSP,
      ekipaMP: ukupnoMP,
      ekipaPromasaji, ekipaBodovi,
      protivnikMP, bonusMP,
    });
    setEditMode(false);
    alert('Utakmica azurirana!');
  };

  const mpProtivnik = utakmica.protivnikMP ?? (8 - (utakmica.ekipaMP || 0));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <div>
          <button className="btn-secondary btn-sm" style={{ marginBottom: '8px' }}
            onClick={() => setAktivna({ strana: 'utakmice' })}>← Nazad</button>
          <div className="page-title" style={{ margin: 0 }}>
            {utakmica.domaci ? utakmica.klub : utakmica.protivnik} vs {utakmica.domaci ? utakmica.protivnik : utakmica.klub}
          </div>
          <div style={{ color: '#666688', fontSize: '14px', marginTop: '4px' }}>
            Kolo {utakmica.kolo} • {utakmica.datum} • {utakmica.sezona} • {utakmica.domaci ? 'Domaci' : 'Gost'}
          </div>
        </div>
        {jeAdmin && (
          <div style={{ display: 'flex', gap: '8px' }}>
            {!editMode ? (
              <button className="btn-edit" onClick={initEdit}>✏️ Uredi</button>
            ) : (
              <>
                <button className="btn-secondary" onClick={() => setEditMode(false)}>Odustani</button>
                <button className="btn-primary" onClick={handleSacuvaj}>Sacuvaj izmjene</button>
              </>
            )}
            <button className="btn-danger" onClick={() => {
              if (window.confirm('Obrisati utakmicu?')) {
                obrisiUtakmicu(utakmica.id);
                setAktivna({ strana: 'utakmice' });
              }
            }}>Obrisi</button>
          </div>
        )}
      </div>

      {editMode && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <div className="section-title">Informacije o utakmici</div>
          <div className="form-row">
            <div className="form-group">
              <label>Datum</label>
              <input type="date" value={editInfo.datum}
                onChange={e => setEditInfo(prev => ({ ...prev, datum: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Kolo</label>
              <input type="number" value={editInfo.kolo}
                onChange={e => setEditInfo(prev => ({ ...prev, kolo: e.target.value }))}
                style={{ width: '80px' }} />
            </div>
            <div className="form-group">
              <label>Sezona</label>
              <select value={editInfo.sezona}
                onChange={e => setEditInfo(prev => ({ ...prev, sezona: e.target.value }))}>
                {SEZONE.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Nas klub</label>
              <select value={editInfo.klub}
                onChange={e => setEditInfo(prev => ({ ...prev, klub: e.target.value }))}>
                {KLUBOVI.map(k => <option key={k}>{k}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Protivnik</label>
              <input value={editInfo.protivnik}
                onChange={e => setEditInfo(prev => ({ ...prev, protivnik: e.target.value }))}
                style={{ width: '160px' }} />
            </div>
            <div className="form-group">
              <label>Cunjevi protivnika</label>
              <input type="number" value={editInfo.protivnikCunjevi}
                onChange={e => setEditInfo(prev => ({ ...prev, protivnikCunjevi: e.target.value }))}
                style={{ width: '110px' }} />
            </div>
            <div className="form-group">
              <label>Domaci/Gost</label>
              <select value={editInfo.domaci ? 'domaci' : 'gost'}
                onChange={e => setEditInfo(prev => ({ ...prev, domaci: e.target.value === 'domaci' }))}>
                <option value="domaci">Domaci</option>
                <option value="gost">Gost</option>
              </select>
            </div>
            <div className="form-group">
              <label>Takmicenje</label>
              <select value={editInfo.takmicenje || 'Premijer liga'}
                onChange={e => setEditInfo(prev => ({ ...prev, takmicenje: e.target.value }))}>
                {TAKMICENJA.map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
          </div>
        </div>
      )}

      {!editMode && (
        <div className="card" style={{ marginBottom: '20px', padding: '16px 20px' }}>
          <div style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '11px', color: '#666688', textTransform: 'uppercase', marginBottom: '4px' }}>
                {utakmica.domaci ? utakmica.klub : utakmica.protivnik} (D)
              </div>
              <div style={{ fontSize: '36px', fontWeight: '700', color: utakmica.domaci ? '#fff' : '#666688' }}>
                {utakmica.domaci ? utakmica.ekipaUkupno : (utakmica.protivnikCunjevi || '?')}
              </div>
              <div style={{ fontSize: '13px', color: '#666688' }}>cunjeva</div>
            </div>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <div style={{ fontSize: '13px', color: '#666688', marginBottom: '4px' }}>MP</div>
              <div style={{ fontSize: '28px', fontWeight: '700' }}>
                {utakmica.domaci ? (
                  <>
                    <span style={{ color: utakmica.ekipaBodovi === 2 ? '#2ed573' : utakmica.ekipaBodovi === 1 ? '#5378ff' : '#e94560' }}>{utakmica.ekipaMP}</span>
                    <span style={{ color: '#2a2a4a', margin: '0 8px' }}>:</span>
                    <span style={{ color: '#666688' }}>{mpProtivnik}</span>
                  </>
                ) : (
                  <>
                    <span style={{ color: '#666688' }}>{mpProtivnik}</span>
                    <span style={{ color: '#2a2a4a', margin: '0 8px' }}>:</span>
                    <span style={{ color: utakmica.ekipaBodovi === 2 ? '#2ed573' : utakmica.ekipaBodovi === 1 ? '#5378ff' : '#e94560' }}>{utakmica.ekipaMP}</span>
                  </>
                )}
              </div>
              {utakmica.bonusMP > 0 && (
                <div style={{ fontSize: '12px', color: '#ffc107', marginBottom: '4px' }}>
                  +{utakmica.bonusMP} bonus MP
                </div>
              )}
              <span className={"badge " + (utakmica.ekipaBodovi === 2 ? 'badge-green' : utakmica.ekipaBodovi === 1 ? 'badge-blue' : 'badge-red')}
                style={{ fontSize: '14px', padding: '4px 16px' }}>
                {utakmica.ekipaBodovi === 2 ? 'Pobjeda' : utakmica.ekipaBodovi === 1 ? 'Remi' : 'Poraz'} ({utakmica.ekipaBodovi} boda)
              </span>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '11px', color: '#666688', textTransform: 'uppercase', marginBottom: '4px' }}>
                {utakmica.domaci ? utakmica.protivnik : utakmica.klub} (G)
              </div>
              <div style={{ fontSize: '36px', fontWeight: '700', color: utakmica.domaci ? '#666688' : '#fff' }}>
                {utakmica.domaci ? (utakmica.protivnikCunjevi || '?') : utakmica.ekipaUkupno}
              </div>
              <div style={{ fontSize: '13px', color: '#666688' }}>cunjeva</div>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '24px' }}>
        {[
          { naziv: 'Ukupno cunjeva', vrijednost: utakmica.ekipaUkupno },
          { naziv: 'Promasaji', vrijednost: utakmica.ekipaPromasaji || 0 },
          { naziv: 'SP', vrijednost: utakmica.ekipaSP },
          { naziv: 'MP nasi', vrijednost: utakmica.ekipaMP },
          { naziv: 'MP protivnik', vrijednost: mpProtivnik },
          { naziv: 'Bonus MP', vrijednost: utakmica.bonusMP || 0 },
        ].map(s => (
          <div key={s.naziv} className="stat-card">
            <div className="broj">{s.vrijednost}</div>
            <div className="naziv">{s.naziv}</div>
          </div>
        ))}
      </div>

      {!editMode && utakmica.rezultati?.some(r => r.izmjena) && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <div className="section-title">Izmjene u utakmici</div>
          {utakmica.rezultati?.filter(r => r.izmjena).map((igrac, i) => {
            const hitac = getUkupnoHitac(igrac.izmjena);
            return (
              <div key={i} style={{ fontSize: '14px', color: '#d0d0d0', marginBottom: '6px' }}>
                {igrac.izmjena.tip === 'izlaz' ? (
                  <span>↑ <span style={{ color: '#e94560' }}>{igrac.ime}</span> izlazi na bacanju {hitac}</span>
                ) : (
                  <span>↓ <span style={{ color: '#2ed573' }}>{igrac.ime}</span> ulazi na bacanju {hitac}</span>
                )}
              </div>
            );
          })}
        </div>
      )}

      <div className="card">
        <div className="section-title">Rezultati igraca</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {[
            ...(utakmica.rezultati || []),
            ...editIzmjene
              .filter(iz => iz.noviIgrac)
              .map(iz => ({ igracId: iz.igracId, ime: iz.ime, ukupno: 0, sp: 0, mp: 0, promasaji: 0, ukupnoPune: 0, ukupnoCis: 0 }))
          ].map((igrac) => {
            const r = rezultati?.[igrac.igracId] || {};
            const napredna = editMode ? r.napredna : igrac.napredna;
            const stat = editMode ? izracunajIgraca(igrac.igracId) : null;
            const ukupno = editMode ? stat.ukupno : igrac.ukupno;
            const sp = editMode ? stat.sp : igrac.sp;
            const mp = editMode ? stat.mp : igrac.mp;
            const promasaji = editMode ? stat.promasaji : igrac.promasaji || 0;
            const ukupnoPune = editMode ? stat.ukupnoPune : igrac.ukupnoPune || 0;
            const ukupnoCis = editMode ? stat.ukupnoCis : igrac.ukupnoCis || 0;
            const izmjenaEdit = editIzmjene.find(iz => iz.igracId === igrac.igracId);

            return (
              <div key={igrac.igracId} style={{ background: '#12122a', borderRadius: '8px', padding: '12px 16px', border: '1px solid #2a2a4a' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
                  <div>
                    {editMode ? (
                      <div className="form-group" style={{ margin: 0 }}>
                        <label style={{ fontSize: '11px' }}>Igrac</label>
                        <select
                          value={izmjenaEdit?.igracIdEdit || igrac.igracId}
                          onChange={e => {
                            const odabrani = igraci.find(i => i.id === e.target.value);
                            updateIzmjena(igrac.igracId, 'igracIdEdit', e.target.value);
                            updateIzmjena(igrac.igracId, 'ime', odabrani?.ime || igrac.ime);
                          }}
                          style={{ fontSize: '13px', minWidth: '200px', padding: '5px 8px', background: '#16162a', color: '#fff', border: '1px solid #2a2a4a', borderRadius: '6px' }}>
                          {[...igraci].sort((a, b) => a.ime.localeCompare(b.ime)).map(i => (
                            <option key={i.id} value={i.id}>{i.ime} ({i.klub})</option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div style={{ fontWeight: '600', color: '#fff', fontSize: '15px' }}>{igrac.ime}</div>
                    )}
                    {!editMode && igrac.izmjena && (
                      <div style={{ fontSize: '11px', color: igrac.izmjena.tip === 'izlaz' ? '#e94560' : '#2ed573', marginTop: '2px' }}>
                        {igrac.izmjena.tip === 'izlaz'
                          ? "↑ izlaz na bacanju " + getUkupnoHitac(igrac.izmjena)
                          : "↓ ulaz na bacanju " + getUkupnoHitac(igrac.izmjena)}
                      </div>
                    )}
                  </div>
                  {!editMode && !napredna && (
                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#666688' }}>Pune</div>
                        <div style={{ fontWeight: '600', color: '#fff' }}>{ukupnoPune}</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#666688' }}>Ciscenje</div>
                        <div style={{ fontWeight: '600', color: '#fff' }}>{ukupnoCis}</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#666688' }}>Ukupno</div>
                        <div style={{ fontWeight: '700', color: '#e94560', fontSize: '18px' }}>{ukupno}</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#666688' }}>Promasaji</div>
                        <div style={{ fontWeight: '600', color: '#666688' }}>{promasaji}</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#666688' }}>SP</div>
                        <div style={{ fontWeight: '700', color: '#2ed573' }}>{sp}</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '11px', color: '#666688' }}>MP</div>
                        <div style={{ fontWeight: '700', color: '#5378ff' }}>{mp}</div>
                      </div>
                    </div>
                  )}
                </div>

                {editMode && izmjenaEdit && (
                  <div style={{ background: '#0f0f1a', borderRadius: '6px', padding: '12px 16px', marginBottom: '12px', border: '1px solid #2a2a4a' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                        <input type="checkbox"
                          checked={izmjenaEdit.imaIzmjenu}
                          onChange={e => updateIzmjena(igrac.igracId, 'imaIzmjenu', e.target.checked)}
                          style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: '#e94560' }} />
                        <span style={{ fontSize: '13px', color: '#aaa', fontWeight: '500' }}>Izmjena</span>
                      </label>
                      {izmjenaEdit.imaIzmjenu && (
                        <>
                          <div className="form-group" style={{ margin: 0 }}>
                            <label style={{ fontSize: '11px' }}>Tip</label>
                            <select value={izmjenaEdit.tip}
                              onChange={e => updateIzmjena(igrac.igracId, 'tip', e.target.value)}
                              style={{ padding: '5px 8px', fontSize: '13px', background: '#16162a', color: '#fff', border: '1px solid #2a2a4a', borderRadius: '6px' }}>
                              <option value="izlaz">↑ Izlazi</option>
                              <option value="ulaz">↓ Ulazi</option>
                            </select>
                          </div>
                          <div className="form-group" style={{ margin: 0 }}>
                            <label style={{ fontSize: '11px' }}>Na bacanju (1-120)</label>
                            <input type="number" min="1" max="120"
                              value={izmjenaEdit.ukupnoHitac || ''}
                              onChange={e => updateIzmjena(igrac.igracId, 'ukupnoHitac', e.target.value)}
                              style={{ width: '80px', padding: '5px 8px', fontSize: '13px' }} />
                          </div>
                          {izmjenaEdit.tip === 'izlaz' && (
                            <div className="form-group" style={{ margin: 0 }}>
                              <label style={{ fontSize: '11px' }}>Igrac koji ulazi</label>
                              <select
                                value={izmjenaEdit.igracKojiUlaziId || ''}
                                onChange={e => {
                                  const odabrani = igraci.find(i => i.id === e.target.value);
                                  updateIzmjena(igrac.igracId, 'igracKojiUlaziId', e.target.value);
                                  updateIzmjena(igrac.igracId, 'igracKojiUlaziIme', odabrani?.ime || '');
                                  if (odabrani && !rezultati[odabrani.id]) {
                                    setRezultati(prev => ({
                                      ...prev,
                                      [odabrani.id]: {
                                        ukupnoPune: 0, ukupnoCis: 0, promasajiOsnovni: 0,
                                        sp: 0, mp: 0, napredna: false,
                                        1: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
                                        2: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
                                        3: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
                                        4: { pune: 0, cis: 0, sp: 0, promasaji: 0 },
                                      }
                                    }));
                                    setEditIzmjene(prev => {
                                      const vecPostoji = prev.some(iz => iz.igracId === odabrani.id);
                                      if (vecPostoji) return prev;
                                      return [...prev, {
                                        igracId: odabrani.id,
                                        igracIdEdit: odabrani.id,
                                        ime: odabrani.ime,
                                        imaIzmjenu: true,
                                        tip: 'ulaz',
                                        ukupnoHitac: izmjenaEdit.ukupnoHitac || '',
                                        igracKojiUlaziId: '',
                                        igracKojiUlaziIme: '',
                                        noviIgrac: true,
                                      }];
                                    });
                                  }
                                }}
                                style={{ padding: '5px 8px', fontSize: '13px', background: '#16162a', color: '#fff', border: '1px solid #2a2a4a', borderRadius: '6px', minWidth: '160px' }}>
                                <option value="">-- niko --</option>
                                {[...igraci].filter(i => i.klub === (editInfo.klub || utakmica.klub)).sort((a, b) => a.ime.localeCompare(b.ime)).map(i => (
                                  <option key={i.id} value={i.id}>{i.ime}</option>
                                ))}
                              </select>
                            </div>
                          )}
                          {izmjenaEdit.ukupnoHitac > 0 && (
                            <div style={{ fontSize: '12px' }}>
                              {izmjenaEdit.tip === 'izlaz' ? (
                                <span style={{ color: '#e94560' }}>Bacio {parseInt(izmjenaEdit.ukupnoHitac) - 1} kugli</span>
                              ) : (
                                <span style={{ color: '#2ed573' }}>Baca {120 - (parseInt(izmjenaEdit.ukupnoHitac) - 1)} kugli</span>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}

                {editMode && (() => {
                  const imaIzmjenu = izmjenaEdit?.imaIzmjenu;
                  const hitac = parseInt(izmjenaEdit?.ukupnoHitac) || 0;
                  const tip = izmjenaEdit?.tip || 'izlaz';

                  let setOd = 1, setDo = 4;
                  if (imaIzmjenu && hitac > 0) {
                    if (tip === 'izlaz') {
                      // Izlaz na hitcu X = bacio X-1 kugli = Math.ceil((X-1)/30) setova
                      const kugleBacene = hitac - 1;
                      setDo = kugleBacene === 0 ? 1 : Math.min(Math.ceil(kugleBacene / 30), 4);
                    } else {
                      // Ulaz na hitcu X = pocinje u setu Math.ceil(X/30)
                      setOd = Math.min(Math.ceil(hitac / 30), 4);
                    }
                  }

                  const setoviZaPrikaz = [];
                  for (let s = setOd; s <= setDo; s++) setoviZaPrikaz.push(s);

                  if (imaIzmjenu && hitac > 0) {
                    return (
                      <div style={{ overflowX: 'auto', marginTop: '8px' }}>
                        <div style={{ fontSize: '12px', color: '#666688', marginBottom: '8px' }}>
                          {tip === 'izlaz'
                            ? 'Igrac izlazi na hitcu ' + hitac + ' — unesi setove 1-' + setDo
                            : 'Igrac ulazi na hitcu ' + hitac + ' — unesi setove ' + setOd + '-4'}
                        </div>
                        <table style={{ minWidth: '500px', marginBottom: '10px' }}>
                          <thead>
                            <tr>
                              <th>Set</th>
                              <th style={{ textAlign: 'center' }}>Pune</th>
                              <th style={{ textAlign: 'center' }}>Ciscenje</th>
                              <th style={{ textAlign: 'center' }}>Promasaji</th>
                              <th style={{ textAlign: 'center' }}>SP</th>
                              <th style={{ textAlign: 'center' }}>Ukupno</th>
                            </tr>
                          </thead>
                          <tbody>
                            {setoviZaPrikaz.map(si => {
                              const set = r[si] || {};
                              const pune = parseFloat(set.pune) || 0;
                              const cis = parseFloat(set.cis) || 0;
                              return (
                                <tr key={si}>
                                  <td style={{ color: '#e94560', fontWeight: '600' }}>Set {si}</td>
                                  <td style={{ padding: '4px', textAlign: 'center' }}>
                                    <input type="number" min="0" step="0.5" value={set.pune || ''}
                                      onChange={e => updateRezultat(igrac.igracId, si, 'pune', e.target.value)}
                                      style={{ width: '60px', textAlign: 'center' }} />
                                  </td>
                                  <td style={{ padding: '4px', textAlign: 'center' }}>
                                    <input type="number" min="0" step="0.5" value={set.cis || ''}
                                      onChange={e => updateRezultat(igrac.igracId, si, 'cis', e.target.value)}
                                      style={{ width: '60px', textAlign: 'center' }} />
                                  </td>
                                  <td style={{ padding: '4px', textAlign: 'center' }}>
                                    <input type="number" min="0" step="1" value={set.promasaji || ''}
                                      onChange={e => updateRezultat(igrac.igracId, si, 'promasaji', e.target.value)}
                                      style={{ width: '60px', textAlign: 'center' }} />
                                  </td>
                                  <td style={{ padding: '4px', textAlign: 'center' }}>
                                    <input type="number" min="0" max="1" step="0.5" value={set.sp || ''}
                                      onChange={e => updateRezultat(igrac.igracId, si, 'sp', e.target.value)}
                                      style={{ width: '60px', textAlign: 'center' }} />
                                  </td>
                                  <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560' }}>{pune + cis}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <div className="form-row">
                          <div className="form-group">
                            <label>MP</label>
                            <input type="number" min="0" max="1" step="0.5" value={r.mp || ''}
                              onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], mp: e.target.value } }))}
                              style={{ width: '60px' }} />
                          </div>
                          {stat?.ukupno > 0 && (
                            <div className="form-group">
                              <label>Ukupno</label>
                              <div style={{ padding: '9px 0', fontSize: '18px', fontWeight: '700', color: '#e94560' }}>{stat.ukupno}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }

                  return !napredna ? (
                    <div className="form-row">
                      <div className="form-group">
                        <label>Pune</label>
                        <input type="number" min="0" step="0.5" value={r.ukupnoPune || ''}
                          onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], ukupnoPune: e.target.value } }))}
                          style={{ width: '80px' }} />
                      </div>
                      <div className="form-group">
                        <label>Ciscenje</label>
                        <input type="number" min="0" step="0.5" value={r.ukupnoCis || ''}
                          onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], ukupnoCis: e.target.value } }))}
                          style={{ width: '80px' }} />
                      </div>
                      <div className="form-group">
                        <label>Promasaji</label>
                        <input type="number" min="0" step="1" value={r.promasajiOsnovni || ''}
                          onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], promasajiOsnovni: e.target.value } }))}
                          style={{ width: '70px' }} />
                      </div>
                      <div className="form-group">
                        <label>SP</label>
                        <input type="number" min="0" max="6" step="0.5" value={r.sp || ''}
                          onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], sp: e.target.value } }))}
                          style={{ width: '60px' }} />
                      </div>
                      <div className="form-group">
                        <label>MP</label>
                        <input type="number" min="0" max="1" step="0.5" value={r.mp || ''}
                          onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], mp: e.target.value } }))}
                          style={{ width: '60px' }} />
                      </div>
                      {stat?.ukupno > 0 && (
                        <div className="form-group">
                          <label>Ukupno</label>
                          <div style={{ padding: '9px 0', fontSize: '18px', fontWeight: '700', color: '#e94560' }}>{stat.ukupno}</div>
                        </div>
                      )}
                    </div>
                  ) : null;
                })()}

                {napredna && (
                  <div style={{ overflowX: 'auto', marginTop: '8px' }}>
                    <table style={{ minWidth: '550px' }}>
                      <thead>
                        <tr>
                          <th>Set</th>
                          <th style={{ textAlign: 'center' }}>P</th>
                          <th style={{ textAlign: 'center' }}>C</th>
                          <th style={{ textAlign: 'center' }}>Uk</th>
                          <th style={{ textAlign: 'center' }}>Pr</th>
                          <th style={{ textAlign: 'center' }}>SP</th>
                          <th style={{ textAlign: 'center' }}>MP</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[1, 2, 3, 4].map(si => {
                          const setData = editMode ? (r[si] || {}) : (igrac["set" + si] || {});
                          const pune = parseFloat(setData.pune) || 0;
                          const cis = parseFloat(setData.cis) || 0;
                          return (
                            <tr key={si}>
                              <td style={{ color: '#e94560', fontWeight: '600' }}>Set {si}</td>
                              <td style={{ padding: '4px', textAlign: 'center' }}>
                                {editMode ? (
                                  <input type="number" min="0" step="0.5" value={r[si]?.pune || ''}
                                    onChange={e => updateRezultat(igrac.igracId, si, 'pune', e.target.value)}
                                    style={{ width: '50px', textAlign: 'center' }} />
                                ) : pune}
                              </td>
                              <td style={{ padding: '4px', textAlign: 'center' }}>
                                {editMode ? (
                                  <input type="number" min="0" step="0.5" value={r[si]?.cis || ''}
                                    onChange={e => updateRezultat(igrac.igracId, si, 'cis', e.target.value)}
                                    style={{ width: '50px', textAlign: 'center' }} />
                                ) : cis}
                              </td>
                              <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560' }}>{pune + cis}</td>
                              <td style={{ padding: '4px', textAlign: 'center' }}>
                                {editMode ? (
                                  <input type="number" min="0" step="1" value={r[si]?.promasaji || ''}
                                    onChange={e => updateRezultat(igrac.igracId, si, 'promasaji', e.target.value)}
                                    style={{ width: '50px', textAlign: 'center' }} />
                                ) : (setData.promasaji || 0)}
                              </td>
                              <td style={{ padding: '4px', textAlign: 'center' }}>
                                {editMode ? (
                                  <input type="number" min="0" max="1" step="0.5" value={r[si]?.sp || ''}
                                    onChange={e => updateRezultat(igrac.igracId, si, 'sp', e.target.value)}
                                    style={{ width: '50px', textAlign: 'center' }} />
                                ) : (setData.sp || 0)}
                              </td>
                              {si === 1 && (
                                <td rowSpan="4" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                  {editMode ? (
                                    <input type="number" min="0" max="1" step="0.5" value={r.mp || ''}
                                      onChange={e => setRezultati(prev => ({ ...prev, [igrac.igracId]: { ...prev[igrac.igracId], mp: e.target.value } }))}
                                      style={{ width: '50px', textAlign: 'center' }} />
                                  ) : (
                                    <span style={{ fontWeight: '700', color: '#5378ff', fontSize: '16px' }}>{mp}</span>
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                        <tr style={{ borderTop: '1px solid #2a2a4a' }}>
                          <td style={{ fontWeight: '600', color: '#fff' }}>Ukupno</td>
                          <td style={{ textAlign: 'center', color: '#fff' }}>{ukupnoPune}</td>
                          <td style={{ textAlign: 'center', color: '#fff' }}>{ukupnoCis}</td>
                          <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560', fontSize: '16px' }}>{ukupno}</td>
                          <td style={{ textAlign: 'center', color: '#666688' }}>{promasaji}</td>
                          <td style={{ textAlign: 'center', color: '#2ed573', fontWeight: '700' }}>{sp}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DetaljiUtakmice;
